import { AG_GRID_LOCALE_VN } from "@ag-grid-community/locale";
import { Button, ComboboxItem, Flex, Grid, Select, Text } from "@mantine/core";
import { DatePickerInput, YearPickerInput } from "@mantine/dates";
import { randomId, useDisclosure } from "@mantine/hooks";
import {
  IconBuildingCommunity,
  IconCalendar,
  IconCalendarMonth,
  IconCalendarStats,
  IconDirections,
  IconFileTypeCsv,
  IconSearch,
  IconTimelineEventText,
} from "@tabler/icons-react";
import {
  ColDef,
  ColGroupDef,
  DefaultMenuItem,
  GetContextMenuItemsParams,
  GridReadyEvent,
  MenuItemDef,
} from "ag-grid-community";
import {
  GetRowIdParams,
  IServerSideDatasource,
  IServerSideGetRowsRequest,
} from "ag-grid-enterprise";
import { AgGridReact, CustomCellRendererProps } from "ag-grid-react";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useLocation } from "react-router-dom";
import {
  paginationPageSize,
  paginationPageSizeSelector,
  repositoryMdm,
} from "../../../../_base/_const/_constVar";
import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { changeSearchValue } from "../../../../_base/helper/FunctionHelper";
import LoadingOverlayCustom from "../../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_MDM } from "../../../../config";
import { MessageResponse } from "../../../../model/MessageResponse";
import {
  getCommuneSelectNew,
  getProvinceSelectNew,
} from "../../../../service/getSelectApi";

const SalesReportByProvinceOrWard = () => {
  const [loading, setLoading] = useState(true);
  const gridRef = useRef<AgGridReact<any>>(null);
  const [height, setHeight] = useState(810);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const containerStyle = useMemo(() => ({ width: "100%", height: height }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  const [search, setSearch] = useState<any>({
    TuNgay:
      _searchJson && checkedPinSearch
        ? _searchJson?.TuNgay
        : new Date(
            new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              1,
            ).getTime() +
              7 * 3600 * 1000,
          ).toISOString(),
    DenNgay:
      _searchJson && checkedPinSearch
        ? _searchJson?.DenNgay
        : new Date(
            new Date(
              new Date().getFullYear(),
              new Date().getMonth() + 1,
              1,
            ).getTime() +
              7 * 3600 * 1000,
          ).toISOString(),
    LoaiKy: _searchJson && checkedPinSearch ? _searchJson?.LoaiKy : "THANG",
    MaTinh: _searchJson && checkedPinSearch ? _searchJson?.MaTinh : "",
    MaPhuong: _searchJson && checkedPinSearch ? _searchJson?.MaPhuong : "",
    Month:
      _searchJson && checkedPinSearch
        ? _searchJson?.Month
        : String(new Date().getMonth() + 1),
    Quarter: _searchJson && checkedPinSearch ? _searchJson?.Quarter : "",
    Year: _searchJson && checkedPinSearch ? _searchJson?.Year : "",
  });

  const dataQuarter: any[] = [
    { label: "Quý 1 (Tháng 1 - 3)", value: "Q1", startMonth: 1, endMonth: 3 },
    { label: "Quý 2 (Tháng 4 - 6)", value: "Q2", startMonth: 4, endMonth: 6 },
    { label: "Quý 3 (Tháng 7 - 9)", value: "Q3", startMonth: 7, endMonth: 9 },
    {
      label: "Quý 4 (Tháng 10 - 12)",
      value: "Q4",
      startMonth: 10,
      endMonth: 12,
    },
  ];

  const [dataProvince, setDataProvince] = useState<ComboboxItem[]>([]);
  const [dataCommune, setDataCommune] = useState<ComboboxItem[]>([]);

  const [totalRow, setTotalRow] = useState<any[]>([]);

  const fetchData = async (request: IServerSideGetRowsRequest) => {
    open();
    try {
      let url = `/api/v1/BaoCaoBanHangPhuong/get-list?Skip=${
        request.startRow
      }&Take=${Number(request.endRow) - Number(request.startRow)}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (
          Array.isArray(value) &&
          value.length > 0 &&
          !["Month", "Quarter", "Year"].includes(String(key))
        ) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (
          typeof value === "string" &&
          value.length > 0 &&
          !["Month", "Quarter", "Year"].includes(String(key))
        ) {
          params.append(key, value);
        }
      });

      url += `&${params.toString()}`;

      return await repositoryMdm.get<MessageResponse<any[]>>(url);
    } catch (error) {
      console.error(error);
    } finally {
      close();
    }
  };

  const exportDataExcel = async () => {
    open();
    try {
      let url = "";

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (
          Array.isArray(value) &&
          value.length > 0 &&
          !["Month", "Quarter", "Year"].includes(String(key))
        ) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (
          typeof value === "string" &&
          value.length > 0 &&
          !["Month", "Quarter", "Year"].includes(String(key))
        ) {
          params.append(key, value);
        }
      });

      url += `&${params.toString()}`;

      const baseUrl = `/api/v1/BaoCaoBanHangPhuong/export-bao-cao-ban-hang-theo-phuong${url.replace(/^&/, "?")}`;

      const _url = BASE_API_MDM + baseUrl;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "bao-cao-ban-hang-theo-nhom-hang.xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        NotificationExtension.Success("Export Excel thành công !");
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const getDataProvince = async () => {
    const res = await getProvinceSelectNew();

    if (res) {
      const data = res
        ?.filter((i) => i.code && i.name)
        ?.map((i) => ({
          label: String(i.name),
          value: String(i.code),
        }));

      setDataProvince(data);
    }
  };

  const getDataCommune = async () => {
    let url = `/api/v1/TblDmCommuneMoi/get-select?active=true`;

    if (search.MaTinh && search.MaTinh.length > 0) {
      url += `&ProvinceIds=${search.MaTinh}`;
    }

    const res = await repositoryMdm.get<MessageResponse<any>>(url);

    if (res) {
      const data = res?.data
        ?.filter((i: any) => i.text && i.value)
        ?.map((i: any) => ({
          label: String(i.text),
          value: String(i.value),
        }));

      setDataCommune(data);
    }
  };

  const getServerSideDataSource: () => IServerSideDatasource = () => {
    return {
      getRows: async (params) => {
        var response = await fetchData(params.request);
        // adding delay to simulate real server call

        if (response && response.success) {
          params.success({
            rowData: response.data
              .filter((i) => i.mA_TINH !== "TOTAL")
              .map((i, index) => ({
                ...i,
                id: Number(params.request.startRow) + index + 1,
              })),
            rowCount: response.totalCount,
          });

          setLoading(false);
          setTotalRow(
            response.data
              .filter((i) => i.mA_TINH === "TOTAL")
              .map((i) => ({
                ...i,
                id: Number(response?.totalCount) + 1,
              })),
          );
        } else {
          // inform the grid request failed
          params.fail();
          setLoading(false);
          setTotalRow([]);
        }
      },
    };
  };

  const getRowId = useCallback((params: GetRowIdParams) => {
    if (params.data.id != null) {
      return "leaf-" + randomId();
    }
    const rowGroupCols = params.api.getRowGroupColumns();
    const rowGroupColIds = rowGroupCols.map((col) => col.getId()).join("-");
    const thisGroupCol = rowGroupCols[params.level];
    return (
      "group-" +
      rowGroupColIds +
      "-" +
      (params.parentKeys || []).join("-") +
      params.data[thisGroupCol.getColDef().field!]
    );
  }, []);

  const getRowStyle = useCallback((params: any) => {
    if (params.node.rowPinned) {
      return {
        backgroundColor: "#e7f5ff",
        fontWeight: 700,
        fontSize: "14px",
        borderTop: "3px solid #15aabf",
      };
    }
    return undefined;
  }, []);

  const filterParamsDefault = {
    buttons: ["clear", "reset", "apply"],
    debounceMs: 1000,
    maxNumConditions: 5,
  };

  const columnDefs = useMemo<(ColDef | ColGroupDef)[]>(
    () => [
      {
        field: "teN_TINH",
        headerName: "Tỉnh/Thành phố",
      },
      {
        field: "teN_PHUONG",
        headerName: "Phường/Xã",
      },
      {
        field: "sO_LUONG_DON_HANG_KY_NAY",
        headerName: "Số lượng đơn hàng kỳ này",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
        width: 225,
      },
      {
        field: "doanH_THU_KY_NAY",
        headerName: "Doanh thu kỳ này",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "giaM_GIA_KY_NAY",
        headerName: "Giảm giá kỳ này",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "chieT_KHAU_KY_NAY",
        headerName: "Chiết khấu kỳ này",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "saU_CK_GG_KY_NAY",
        headerName: "Sau CK, GG kỳ này",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "tieN_VON_KY_NAY",
        headerName: "Tiền vốn kỳ này",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "tieN_LAI_KY_NAY",
        headerName: "Tiền lãi kỳ này",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "sO_LUONG_DON_HANG_KY_TRUOC",
        headerName: "Số lượng đơn hàng kỳ trước",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
        width: 250,
      },
      {
        field: "doanH_THU_KY_TRUOC",
        headerName: "Doanh thu kỳ trước",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "giaM_GIA_KY_TRUOC",
        headerName: "Giảm giá kỳ trước",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "chieT_KHAU_KY_TRUOC",
        headerName: "Chiết khấu kỳ trước",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "saU_CK_GG_KY_TRUOC",
        headerName: "Sau CK, GG kỳ trước",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "tieN_VON_KY_TRUOC",
        headerName: "Tiền vốn kỳ trước",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "tieN_LAI_KY_TRUOC",
        headerName: "Tiền lãi kỳ trước",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
    ],
    [],
  );

  const defaultColDef = useMemo<ColDef>(() => {
    return {
      autoHeaderHeight: true,
      allowedAggFuncs: ["sum", "min", "max", "avg"],
      filter: false,
      enableRowGroup: true,
      enableValue: true,
      floatingFilter: false,
      floatingFilterComponentParams: {
        showDisabledCheckboxes: true,
      },
      filterParams: filterParamsDefault,
    };
  }, []);

  const defaultColGroupDef = useMemo<Partial<ColGroupDef>>(() => {
    return {
      headerName: "A shared prop for all Groups",
    };
  }, []);

  const onGridReady = useCallback(async (params: GridReadyEvent) => {
    var datasource = getServerSideDataSource();
    // register the datasource with the grid
    params.api!.setGridOption("serverSideDatasource", datasource);
  }, []);

  const handleSearch = useCallback(() => {
    if (gridRef.current && gridRef.current.api) {
      setLoading(true);
      // Lấy datasource mới chứa state search hiện tại
      const datasource = getServerSideDataSource();
      // Set lại datasource để Grid query lại từ đầu (trang 1) với params mới
      gridRef.current.api.setGridOption("serverSideDatasource", datasource);
    }
  }, [search]); // Dependency quan trọng để lấy state mới

  const statusBar = useMemo(
    () => ({
      statusPanels: [
        { statusPanel: "agTotalAndFilteredRowCountComponent" },
        { statusPanel: "agTotalRowCountComponent" },
        { statusPanel: "agFilteredRowCountComponent" },
        { statusPanel: "agSelectedRowCountComponent" },
        { statusPanel: "agAggregationComponent" },
      ],
    }),
    [],
  );

  const getContextMenuItems = useCallback(
    (params: GetContextMenuItemsParams): (DefaultMenuItem | MenuItemDef)[] => {
      var result: (DefaultMenuItem | MenuItemDef)[] = [
        "cut",
        "copy",
        "copyWithHeaders",
        "copyWithGroupHeaders",
        "paste",
        "separator",
        "chartRange",
        "export",
      ];
      return result;
    },
    [window],
  );

  useEffect(() => {
    getDataProvince();
  }, []);

  useEffect(() => {
    getDataCommune();
  }, [search.MaTinh]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (245 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  return (
    <div style={containerStyle}>
      <LoadingOverlayCustom visible={visible} />
      <Flex justify={"space-between"} align={"center"} w={"100%"}>
        <_breadcrumb></_breadcrumb>
        <Flex gap={"md"}>
          <Button
            leftSection={<IconFileTypeCsv size={16} />}
            onClick={() => exportDataExcel()}
          >
            Export Excel
          </Button>
        </Flex>
      </Flex>
      <Grid mb={10}>
        <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
          <Select
            placeholder="Chọn loại thời gian tìm kiếm"
            data={[
              { label: "Ngày", value: "NGAY" },
              { label: "Tháng", value: "THANG" },
              { label: "Quý", value: "QUY" },
              { label: "Năm", value: "NAM" },
            ]}
            leftSection={<IconTimelineEventText color="#15aabf" />}
            value={search.LoaiKy || null}
            onChange={(e) => {
              changeSearchValue(e ? e : "THANG", "LoaiKy", setSearch);

              if (e === "NGAY") {
                setSearch((prev: any) => ({
                  ...prev,
                  TuNgay: new Date(
                    new Date(
                      new Date().getFullYear(),
                      new Date().getMonth(),
                      new Date().getDate(),
                    ).getTime() +
                      7 * 3600 * 1000,
                  ).toISOString(),
                  DenNgay: new Date(
                    new Date(
                      new Date().getFullYear(),
                      new Date().getMonth(),
                      new Date().getDate() + 1,
                    ).getTime() +
                      7 * 3600 * 1000,
                  ).toISOString(),
                }));
              }

              if (e === "THANG" || !e) {
                setSearch((prev: any) => ({
                  ...prev,
                  TuNgay: new Date(
                    new Date(
                      new Date().getFullYear(),
                      new Date().getMonth(),
                      1,
                    ).getTime() +
                      7 * 3600 * 1000,
                  ).toISOString(),
                  DenNgay: new Date(
                    new Date(
                      new Date().getFullYear(),
                      new Date().getMonth() + 1,
                      1,
                    ).getTime() +
                      7 * 3600 * 1000,
                  ).toISOString(),
                  Month: String(new Date().getMonth() + 1),
                }));
              }

              if (e === "QUY") {
                setSearch((prev: any) => ({
                  ...prev,
                  Quarter: dataQuarter.find(
                    (i) =>
                      i.startMonth <= new Date().getMonth() + 1 &&
                      i.endMonth >= new Date().getMonth() + 1,
                  )?.value,
                  TuNgay: new Date(
                    new Date(
                      new Date().getFullYear(),
                      dataQuarter.find(
                        (i) =>
                          i.startMonth <= new Date().getMonth() + 1 &&
                          i.endMonth >= new Date().getMonth() + 1,
                      )?.startMonth - 1,
                      1,
                    ).getTime() +
                      7 * 3600 * 1000,
                  ).toISOString(),
                  DenNgay: new Date(
                    new Date(
                      new Date().getFullYear(),
                      dataQuarter.find(
                        (i) =>
                          i.startMonth <= new Date().getMonth() + 1 &&
                          i.endMonth >= new Date().getMonth() + 1,
                      )?.endMonth,
                      1,
                    ).getTime() +
                      7 * 3600 * 1000,
                  ).toISOString(),
                }));
              }

              if (e === "NAM") {
                setSearch((prev: any) => ({
                  ...prev,
                  Year: String(new Date().getFullYear()),
                  TuNgay: new Date(
                    new Date(new Date().getFullYear(), 0, 1).getTime() +
                      7 * 3600 * 1000,
                  ).toISOString(),
                  DenNgay: new Date(
                    new Date(new Date().getFullYear() + 1, 0, 1).getTime() +
                      7 * 3600 * 1000,
                  ).toISOString(),
                }));
              }
            }}
          />
        </Grid.Col>
        {search.LoaiKy === "THANG" && (
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Chọn tháng"
              leftSection={<IconCalendarMonth color="#15aabf" />}
              data={[
                { label: "Tháng 1", value: "1" },
                { label: "Tháng 2", value: "2" },
                { label: "Tháng 3", value: "3" },
                { label: "Tháng 4", value: "4" },
                { label: "Tháng 5", value: "5" },
                { label: "Tháng 6", value: "6" },
                { label: "Tháng 7", value: "7" },
                { label: "Tháng 8", value: "8" },
                { label: "Tháng 9", value: "9" },
                { label: "Tháng 10", value: "10" },
                { label: "Tháng 11", value: "11" },
                { label: "Tháng 12", value: "12" },
              ]}
              value={search.Month || null}
              onChange={(e) => {
                setSearch((prev: any) => ({
                  ...prev,
                  Month: e ? e : "",
                  TuNgay: new Date(
                    new Date(
                      new Date().getFullYear(),
                      Number(e) - 1,
                      1,
                    ).getTime() +
                      7 * 3600 * 1000,
                  ).toISOString(),
                  DenNgay: new Date(
                    new Date(new Date().getFullYear(), Number(e), 1).getTime() +
                      7 * 3600 * 1000,
                  ).toISOString(),
                }));
              }}
            />
          </Grid.Col>
        )}
        {search.LoaiKy === "QUY" && (
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Chọn quý"
              leftSection={<IconCalendarMonth color="#15aabf" />}
              data={dataQuarter.map((i) => ({
                label: i.label,
                value: i.value,
              }))}
              value={search.Quarter || null}
              onChange={(e) => {
                setSearch((prev: any) => ({
                  ...prev,
                  Quarter: e ? e : "",
                  TuNgay: new Date(
                    new Date(
                      new Date().getFullYear(),
                      dataQuarter.find((i) => i.value === e)?.startMonth - 1,
                      1,
                    ).getTime() +
                      7 * 3600 * 1000,
                  ).toISOString(),
                  DenNgay: new Date(
                    new Date(
                      new Date().getFullYear(),
                      dataQuarter.find((i) => i.value === e)?.endMonth,
                      1,
                    ).getTime() +
                      7 * 3600 * 1000,
                  ).toISOString(),
                }));
              }}
            />
          </Grid.Col>
        )}
        {search.LoaiKy === "NAM" && (
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <YearPickerInput
              placeholder="Chọn năm"
              leftSection={<IconCalendarStats color="#15aabf" />}
              value={new Date(Number(search.Year), 0, 1)}
              onChange={(e) => {
                setSearch((prev: any) => ({
                  ...prev,
                  Year: String(new Date(e || "").getFullYear()),
                  TuNgay: new Date(
                    new Date(new Date(e || "").getFullYear(), 0, 1).getTime() +
                      7 * 3600 * 1000,
                  )?.toISOString(),
                  DenNgay: new Date(
                    new Date(
                      new Date(e || "").getFullYear() + 1,
                      0,
                      1,
                    ).getTime() +
                      7 * 3600 * 1000,
                  ).toISOString(),
                }));
              }}
            />
          </Grid.Col>
        )}
        <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
          <DatePickerInput
            size="sm"
            placeholder="Chọn ngày bắt đầu"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            value={
              search.TuNgay && search.TuNgay?.length > 0
                ? new Date(search.TuNgay ?? "")
                : null
            }
            maxDate={
              search.DenNgay && search.DenNgay?.length > 0
                ? new Date(search.DenNgay)
                : new Date()
            }
            onChange={(e) => {
              changeSearchValue(
                e
                  ? new Date(
                      new Date(e).getTime() + 7 * 3600 * 1000,
                    )?.toISOString()
                  : "",
                "TuNgay",
                setSearch,
              );
            }}
            leftSection={<IconCalendar color="#15aabf" />}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
          <DatePickerInput
            size="sm"
            placeholder="Chọn ngày kết thúc"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            value={
              search.DenNgay && search.DenNgay?.length > 0
                ? new Date(search.DenNgay ?? "")
                : null
            }
            minDate={
              search.TuNgay && search.TuNgay?.length > 0
                ? new Date(search.TuNgay)
                : undefined
            }
            onChange={(e) => {
              changeSearchValue(
                e
                  ? new Date(
                      new Date(e).getTime() + 7 * 3600 * 1000,
                    )?.toISOString()
                  : "",
                "DenNgay",
                setSearch,
              );
            }}
            leftSection={<IconCalendar color="#15aabf" />}
          />
        </Grid.Col>
        {/* <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
          <Select
            placeholder="Tỉnh/Thành phố"
            leftSection={<IconBuildingCommunity color="#15aabf" />}
            data={dataProvince}
            searchable
            clearable
            value={search.MaTinh || null}
            onChange={(e) => changeSearchValue(e ? e : "", "MaTinh", setSearch)}
            nothingFoundMessage="Không tìm thấy dữ liệu !"
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
          <Select
            placeholder="Phường/Xã"
            leftSection={<IconDirections color="#15aabf" />}
            data={dataCommune}
            searchable
            clearable
            value={search.MaPhuong || null}
            onChange={(e) =>
              changeSearchValue(e ? e : "", "MaPhuong", setSearch)
            }
            nothingFoundMessage="Không tìm thấy dữ liệu !"
          />
        </Grid.Col> */}
        <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
          <Button
            leftSection={<IconSearch size={14} />}
            onClick={() => handleSearch()}
          >
            Tìm kiếm
          </Button>
        </Grid.Col>
      </Grid>
      <div style={gridStyle} className={"ag-theme-quartz"}>
        <AgGridReact<any>
          ref={gridRef}
          loading={loading}
          suppressNoRowsOverlay
          columnDefs={columnDefs}
          defaultColGroupDef={defaultColGroupDef}
          defaultColDef={defaultColDef}
          rowModelType={"serverSide"}
          pagination={true}
          paginationPageSize={paginationPageSize}
          paginationPageSizeSelector={paginationPageSizeSelector}
          cacheBlockSize={paginationPageSize}
          maxBlocksInCache={10}
          onGridReady={onGridReady}
          localeText={AG_GRID_LOCALE_VN}
          sideBar={true}
          enableAdvancedFilter={false}
          masterDetail={true}
          // detailCellRendererParams={detailCellRendererParams}
          rowSelection={"multiple"}
          suppressAggFuncInHeader={true}
          getRowId={getRowId}
          suppressRowClickSelection={true}
          groupSelectsChildren={true}
          blockLoadDebounceMillis={200}
          suppressServerSideFullWidthLoadingRow={false}
          maxConcurrentDatasourceRequests={1}
          animateRows={true}
          rowBuffer={paginationPageSize}
          purgeClosedRowNodes={true}
          pivotPanelShow={"always"}
          rowGroupPanelShow={"always"}
          statusBar={statusBar}
          enableRangeSelection
          enableCharts
          allowContextMenuWithControlKey={true}
          getContextMenuItems={getContextMenuItems}
          suppressColumnVirtualisation
          paginateChildRows={true}
          paginationAutoPageSize={true}
          pinnedBottomRowData={totalRow}
          getRowStyle={getRowStyle}
        />
      </div>
    </div>
  );
};

export default SalesReportByProvinceOrWard;
